module.exports = __webpack_public_path__ + "static/media/icon_marathon.b157e5ca.ico";